import { render, staticRenderFns } from "./ProjectAddVersionModal.vue?vue&type=template&id=587b63fe&scoped=true&"
import script from "./ProjectAddVersionModal.vue?vue&type=script&lang=js&"
export * from "./ProjectAddVersionModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAddVersionModal.vue?vue&type=style&index=0&id=587b63fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587b63fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('587b63fe')) {
      api.createRecord('587b63fe', component.options)
    } else {
      api.reload('587b63fe', component.options)
    }
    module.hot.accept("./ProjectAddVersionModal.vue?vue&type=template&id=587b63fe&scoped=true&", function () {
      api.rerender('587b63fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/ProjectAddVersionModal.vue"
export default component.exports